import React from 'react'

import { ThemeProvider } from 'styled-components'

import { AuthState } from './components/AuthState'
import { RoomsPane } from './components/RoomsPane'
import { useRoomsTaskpane } from './hooks/useRoomsTaskpane'
import { GlobalStyles } from './styles/GlobalStyles'
import { theme } from './styles/theme'

export default function App() {
    const controller = useRoomsTaskpane()

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            {controller.status !== 'ready' ? (
                <AuthState
                    isError={controller.status === 'error'}
                    message={controller.authMessage}
                    onRetry={controller.retry}
                />
            ) : (
                <RoomsPane
                    offices={controller.offices}
                    selectedOffice={controller.selectedOffice}
                    searchTerm={controller.searchTerm}
                    isOfficeOpen={controller.isOfficeOpen}
                    isFilterOpen={controller.isFilterOpen}
                    availableTags={controller.availableTags}
                    activeTagIds={controller.activeTagIds}
                    minCapacity={controller.minCapacity}
                    capacityOptions={controller.capacityOptions}
                    filteredGroups={controller.filteredGroups}
                    roomAvailabilityById={controller.roomAvailabilityById}
                    roomsLoadingMessage={controller.roomsLoadingMessage}
                    roomsLoaded={controller.roomsLoaded}
                    attachedRoomId={controller.attachedRoomId}
                    attachedRoomLabel="Attached"
                    attachError={controller.attachError}
                    attachingRoomId={controller.attachingRoomId}
                    startTimeLabel={controller.startTimeLabel}
                    endTimeLabel={controller.endTimeLabel}
                    officeSelectRef={controller.officeSelectRef}
                    filterPanelRef={controller.filterPanelRef}
                    filterTriggerRef={controller.filterTriggerRef}
                    onSearchChange={controller.setSearchTerm}
                    onMinCapacityChange={controller.setMinCapacity}
                    onToggleOfficeOpen={controller.toggleOfficeOpen}
                    onToggleFilterOpen={controller.toggleFilterOpen}
                    onSelectOffice={controller.selectOffice}
                    onToggleTag={controller.toggleTag}
                    onClearTags={controller.clearTags}
                    onToggleGroup={controller.toggleGroup}
                    onAttachRoom={controller.attachMappedRoomToAppointment}
                />
            )}
        </ThemeProvider>
    )
}
